/**
 * Utility functions to help with environment variables
 */
import logger from './logger';

// Return current environment mode
export const isDevelopmentMode = () => {
  // Check localStorage first for development mode override
  if (typeof window !== 'undefined' && window.localStorage) {
    const forceDevMode = localStorage.getItem('FORCE_DEV_MODE');
    if (forceDevMode === 'true') {
      logger.info('*** USING FORCED DEVELOPMENT MODE FROM LOCALSTORAGE ***');
      return true;
    }
    
    // Check if user wants to force using real Firebase
    const useRealFirebase = localStorage.getItem('USE_REAL_FIREBASE');
    if (useRealFirebase === 'true') {
      // Silently use real Firebase
      return false; // Return false to ensure real Firebase is used
    }
  }
  
  // Then check environment variable
  const isDev = process.env.REACT_APP_ENV === 'development';
  return isDev;
}

// Check if Firebase is configured
export const isFirebaseConfigured = () => {
  return !!process.env.REACT_APP_FIREBASE_API_KEY && 
         !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN &&
         !!process.env.REACT_APP_FIREBASE_DATABASE_URL &&
         !!process.env.REACT_APP_FIREBASE_PROJECT_ID &&
         !!process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
};

const exportedObject = {
  isDevelopmentMode,
  isFirebaseConfigured
};

export default exportedObject;